import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/sellers/')({
  beforeLoad: () => {
    throw redirect({ to: '/customers' });
  },
});
